import React, { useState, useEffect, useRef } from "react";
import moment from "moment";
import {
  Grid,
  Button,
  Box,
  TextField,
  FormControl,
  InputLabel,
  Typography,
  Backdrop,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogActions,
  MenuItem,
  Select,
  TablePagination,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { Controller, useForm } from "react-hook-form";
import InterFont from "../../../fonts/Inter.ttf";
import { jwtDecode } from "jwt-decode";
import jsPDF from "jspdf";
import { useLocation, useHistory } from "react-router-dom";
import { IoChevronDownSharp } from "react-icons/io5";
import { useNotification } from "../../../hooks/useNotification.js";
import CustomPdfView from "../../../components/pdfViewer/CustomPdfView.js";
import CloseIcon from "@material-ui/icons/Close";
import NoDataFound from "../../../components/NoDataFound/index.js";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Alert, AlertTitle } from "@material-ui/lab";
import PaySlipTable from "./PaySlipTable.js";
import "../../../scss/employee.scss";
import useStyles from "../../../themes/style.js";
import { calculateProRatedTax } from "./calculation/calucluations.js";
import PayslipDetails from "./PaySlipDetails.js";

function MyPaySlips() {
  const classes = useStyles();
  const payslipFileRef = useRef(null);
  const token = localStorage.getItem("token");
  const history = useHistory();
  const location = useLocation();
  const userId = new URLSearchParams(location.search).get("userId");
  const handleNotificationCall = useNotification();
  const [loader, setLoader] = useState(false);
  const [payslipData, setPayslipdata] = useState([]);
  const [userData, setUserData] = useState(null);
  const [leaveData, setLeaveData] = useState([]);
  const [paymentDate, setPaymentDate] = useState(new Date());
  const [lopDays, setLopDays] = useState(0);
  const [calendarOpen, setCalendarOpen] = useState(false);

  const [payslipInfo, setPayslipInfo] = useState({
    masterValues: {
      basicSalary: 0,
      hra: 0,
      specialAllowance: 0,
      shiftAllowance: 0,
      otherAllowance: 0,
      telephoneAllowance: 0,
      conveyance: 0,
      medicalAllowance: 0,
      basicAllowance: 0,
      consultant: 0,
      statutoryBonus: 0,
      statutoryApplicability: 0,
    },
    grossValues: {
      basicSalary: 0,
      hra: 0,
      specialAllowance: 0,
      shiftAllowance: 0,
      otherAllowance: 0,
      telephoneAllowance: 0,
      conveyance: 0,
      medicalAllowance: 0,
      basicAllowance: 0,
      consultant: 0,
      statutoryBonus: 0,
      statutoryApplicability: 0,
    },
    deductionValues: {
      pf: 0,
      esi: 0,
      incomeTax: 0,
      labourWelfareFund: 0,
      otherDeduction: 0,
      professionalTax: 0,
      noticePeriodDeduction: 0,
      standardDeduction: 0,
      specialPurposeDeduction: 0,
      loan: 0,
    },
    earningValues: {
      hraArrears: 0,
      shiftAllowanceArrears: 0,
      otherAllowanceArrear: 0,
      telephoneAllowanceArrear: 0,
      conveyanceArrears: 0,
      medicalAllowanceArrear: 0,
      basicAllowanceArrears: 0,
      arrears: 0,
      consultantArrears: 0,
      monthlyPerformanceArrears: 0,
      bonus: 0,
      incentives: 0,
      otherEarnings: 0,
      refundForLastMonthDeduction: 0,
      rolePerformanceBonus: 0,
    },
    totalDeduction: 0,
    totalMaster: 0,
    totalGross: 0,
    totalEarnings: 0,
    netValue: 0,
    effective_work_days: 0,
    lopCount: 0,
    isProcessed: {
      payForLoan: true,
      status: false,
      id: "",
      processedDate: "",
    },
  });

  const [salaryData, setSalaryData] = useState({
    conveyance: "",
    profTax: "",
  });

  const [page, setPage] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [count, setCount] = useState(0);

  const [salaryPayslipData, setSalaryPayslipData] = useState({
    basic: 0,
    hra: 0,
    specialAllowance: 0,
    shiftAllowance: 0,
    otherAllowance: 0,
    statutoryBonus: 0,

    telephoneAllowance: 0,
    conveyance: 0,
    medicalAllowance: 0,
    basicAllowance: 0,
    consultant: 0,
    statutoryApplicability: 0,

    employeeESI: 0,
    employeePF: 0,
    professionalTax: 0,
    totalGrossSalary: 0,
    totalDeductions: 0,
  });

  const [currentSalaryData, setCurrentSalaryData] = useState({
    basic: 0,
    hra: 0,
    specialAllowance: 0,
    shiftAllowance: 0,
    otherAllowance: 0,
    statutoryBonus: 0,

    telephoneAllowance: 0,
    conveyance: 0,
    medicalAllowance: 0,
    basicAllowance: 0,
    consultant: 0,
    statutoryApplicability: 0,

    employeeESI: 0,
    employeePF: 0,
    professionalTax: 0,
    totalGrossSalary: 0,
    totalDeductions: 0,
    lossOfPayDays: 0,
  });

  const [payslipModalOpen, setPayslipModalOpen] = useState(false);
  const [LOPModalOpen, setLOPModalOpen] = useState(false);
  const [payslipConfirmationModal, setPayslipConfirmationModal] = useState(
    false,
  );
  const [payslipView, setPayslipView] = useState({
    isView: false,
    url: "",
  });

  const handleViewPaySlipClose = () => {
    setPayslipView({
      isView: false,
      url: "",
    });
  };

  const handlePayslipModalOpen = () => {
    setPayslipModalOpen(true);
  };

  const handlePayslipModalClose = () => {
    setPayslipModalOpen(false);
  };

  const handleLOPModalOpen = () => {
    setLOPModalOpen(true);
  };

  const handlePayslipMonthChange = (date) => {
    setCalendarOpen(!calendarOpen);
    setPaymentDate(date);
  };
  const handlePayslipCalendarOpen = (e) => {
    e.preventDefault();
    setCalendarOpen(!calendarOpen);
  };

  const handleProcessPayslip = async (type) => {
    const monthIndex = new Date(paymentDate).getMonth();
    const fullyear = new Date(paymentDate).getFullYear();
    const { earningValues, deductionValues } = payslipInfo;

    let url;
    if (type === "PROCESS") {
      url = `${process.env.REACT_APP_SERVER}payslip/processPayslip`;
    } else if (type === "GENERATE") {
      url = `${process.env.REACT_APP_SERVER}payslip/processPayslip?generate=true`;
    } else {
      url = "";
    }
    try {
      setLoader(true);
      axios({
        method: "post",
        url: `${process.env.REACT_APP_SERVER}payslip/processPayslip`,
        data: {
          userId: userId,
          forMonth: monthIndex,
          forYear: fullyear,
          ...earningValues,
          ...deductionValues,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }).then(function (response) {
        setLoader(false);
        if (response.data.status) {
          handleNotificationCall("success", response.data.message);
          getPayslipValues();
        } else {
          handleNotificationCall("error", response.data.message);
        }
      });
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const handleLOPModalClose = () => {
    setLOPModalOpen(false);
  };

  const validationSchema = Yup.object().shape({
    date: Yup.string().required("LOP Date is required"),
    type: Yup.string().required("LOP Type is required"),
  });

  useEffect(() => {
    fetchUserDetails();
    getPayslipValues();
    fetchPayslipDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (paymentDate) {
      getLopDays();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentDate]);

  useEffect(() => {
    // Update the current salary details when professional tax changes
    if (lopDays !== undefined) {
      getCurrentSalaryPayslipDetails(lopDays);
    }
  }, [salaryData.profTax]);


  const handleGeneratePdf = async () => {
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "pt",
      format: "a4",
      compress: true,
      lineHeight: 1.2,
    });

    doc.addFont(InterFont, "Inter", "normal");
    doc.setFont("Inter");
    const element = payslipFileRef.current;
    if (element) {
      await doc.html(element, {
        callback: (doc) => {
          const pdfBlob = doc.output("blob");
          handlePayslipCreate(pdfBlob, doc);
        },
        x: 10,
        y: 10,
        html2canvas: {
          scale: 0.7, // Adjust the scale for better quality
          logging: true, // Enable logging for debugging
          useCORS: true,
          letterRendering: false,
        },
        windowWidth: 800,
      });
    }
  };

  async function handlePayslipCreate(pdfBlob, doc) {
    setLoader(true);
    const monthIndex = new Date(paymentDate).getMonth();
    const formData = new FormData();
    const payslipFile = new File([pdfBlob], `payslip_${Date.now()}.pdf`);
    formData.append("document", payslipFile);
    formData.append("userId", userId);
    formData.append("month", monthIndex);

    axios({
      method: "post",
      url: `${process.env.REACT_APP_SERVER}payslip/sentPayslip`,
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: token,
      },
    }).then(function (response) {
      setLoader(false);
      if (response.data.status === true) {
        handleNotificationCall("success", response.data.message);
        fetchPayslipDetails();
        handlePayslipModalClose();
      } else {
        handleNotificationCall("error", response.data.message);
      }
    });
  }

  const getLopDays = async () => {
    const monthIndex = new Date(paymentDate).getMonth();
    try {
      setLoader(true);
      axios({
        method: "post",
        url: `${process.env.REACT_APP_SERVER}leave/viewUserWiseLop`,
        data: {
          userId: userId,
          month: monthIndex,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }).then(function (response) {
        setLoader(false);
        if (response.data.status === true) {
          const responseData = response.data.data;
          const loss_of_pay_days = responseData.lops.reduce(
            (sum, item) => sum + item.value,
            0,
          );
          setLopDays(loss_of_pay_days);
          getCurrentSalaryPayslipDetails(loss_of_pay_days);
        } else {
          getCurrentSalaryPayslipDetails(0);
        }
      });
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const fetchUserDetails = async () => {
    try {
      setLoader(true);
      axios({
        method: "get",
        url: `${process.env.REACT_APP_SERVER}employee/getUserEmployee?userId=${userId}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }).then(function (response) {
        if (response.data.status === true) {
          setLoader(false);
          const responseData = response.data.data;
          setUserData(responseData);

          getSalaryPayslipDetails(responseData);
        }
      });
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  function getSalaryPayslipDetails(data) {
    if (!data) {
      return;
    }
    //actual fetch datas
    const salaryDetails = data?.salary_detail;
    const employee = data?.employee ? data?.employee : data.recruiter;
    const emp_joiningDate = employee?.joinningDate;

    let basicSalary = Number(salaryDetails?.basicSalary);
    let HRA = Number(salaryDetails?.hra);
    let specialAllowance = Number(salaryDetails?.specialAllowance);
    let shiftAllowance = Number(salaryDetails?.shiftAllowance);
    let otherAllowance = Number(salaryDetails?.otherAllowance);
    let stautoryBonus = Number(salaryDetails?.statutoryBonus);

    let telephoneAllowance = Number(salaryDetails?.telephoneAllowance);
    let conveyance = Number(salaryDetails?.conveyance);
    let medicalAllowance = Number(salaryDetails?.medicalAllowance);
    let basicAllowance = Number(salaryDetails?.basicAllowance);
    let consultant = Number(salaryDetails?.consultant);
    let statutoryApplicability = Number(salaryDetails?.statutoryApplicability);

    let totalGrossSalary =
      basicSalary +
      HRA +
      shiftAllowance +
      specialAllowance +
      stautoryBonus +
      otherAllowance +
      telephoneAllowance +
      conveyance +
      medicalAllowance +
      basicAllowance +
      consultant +
      statutoryApplicability;

    let employeePF = salaryDetails?.isPfPercentage
      ? Math.round(basicSalary * 0.12)
      : 1800;
    let employeeESI =
      totalGrossSalary <= 21000 ? Math.abs(basicSalary * 0.0075) : 0;

    const ProfessionalTax = calculateProRatedTax(
      emp_joiningDate,
      totalGrossSalary,
    );
    let totalDeductions = employeePF + employeeESI + ProfessionalTax;

    setSalaryPayslipData({
      basic: basicSalary,
      hra: HRA,
      specialAllowance: specialAllowance,
      shiftAllowance: shiftAllowance,
      otherAllowance: otherAllowance,
      statutoryBonus: stautoryBonus,

      telephoneAllowance: telephoneAllowance,
      conveyance: conveyance,
      medicalAllowance: medicalAllowance,
      basicAllowance: basicAllowance,
      consultant: consultant,
      statutoryApplicability: statutoryApplicability,

      employeeESI: employeeESI,
      employeePF: employeePF,
      professionalTax: ProfessionalTax,

      totalGrossSalary: totalGrossSalary,
      totalDeductions: totalDeductions,
    });
  }

  function getCurrentSalaryPayslipDetails(lop) {
    if (!userData) {
      return;
    }
    const totalDays = moment(paymentDate, "YYYY-M").daysInMonth();
    const calculateLossFromLOP = (amount) => (amount / totalDays) * lop;

    const {
      basic: basicSalary,
      otherAllowance,
      professionalTax,
    } = salaryPayslipData;
    const lossOfBasicSalary = calculateLossFromLOP(basicSalary);
    const lossOfOtherAllowance = calculateLossFromLOP(otherAllowance);

    const currentBasicSalary = basicSalary - lossOfBasicSalary;
    const currentOtherAllowance = otherAllowance - lossOfOtherAllowance;
    const currentHRA = currentBasicSalary / 2;
    const currentStatutoryBonus = Math.round(currentBasicSalary / 12);

    const totalGrossSalary =
      currentBasicSalary +
      currentHRA +
      currentOtherAllowance +
      currentStatutoryBonus;

    const currentEmployeePF = salaryData?.isPfPercentage
      ? Math.round(currentBasicSalary * 0.12)
      : 1800;
    const currentEmployeeESI =
      totalGrossSalary <= 21000 ? Math.abs(currentBasicSalary * 0.0075) : 0;

    const totalDeductions =
      currentEmployeePF + currentEmployeeESI + professionalTax;

    setCurrentSalaryData({
      basic: currentBasicSalary,
      hra: currentHRA,
      otherAllowance: currentOtherAllowance,
      statutoryBonus: currentStatutoryBonus,
      employeeESI: currentEmployeeESI,
      employeePF: currentEmployeePF,
      professionalTax: professionalTax,
      totalGrossSalary: totalGrossSalary,
      totalDeductions: totalDeductions,
      lossOfPayDays: lop,
    });
  }

  const fetchPayslipDetails = async () => {
    try {
      setLoader(true);
      axios({
        method: "get",
        url: `${process.env.REACT_APP_SERVER}payslip/getUserPayslip?userId=${userId}&page=${currentPage}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }).then(function (response) {
        setLoader(false);
        if (response.data.status === true) {
          const responseData = response.data.data;
          setPayslipdata(responseData);
          setCount(response.data.count);
        }
      });
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const getPayslipValues = async () => {
    const monthIndex = new Date(paymentDate).getMonth();
    const fullyear = new Date(paymentDate).getFullYear();
    setLoader(true);
    try {
      axios({
        method: "post",
        url: `${process.env.REACT_APP_SERVER}payslip/getPayslipValues`,
        data: {
          userId: userId,
          monthIndex: monthIndex,
          year: fullyear,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }).then(function (response) {
        setLoader(false);
        const responseData = response.data.data;
        if (response.data.status === true) {
          setPayslipInfo(responseData);
        }
      });
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setLoader(true);
    setCurrentPage(newPage + 1);

    axios({
      method: "get",
      url: `${process.env.REACT_APP_SERVER}payslip/getUserPayslip?userId=${userId}&page=${currentPage}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
        setPayslipdata(response.data.data);
        setCount(response.data.count);
      }

      setLoader(false);
    });
  };

  const handlePayslipDownload = (item) => {
    window.location.href = `${process.env.REACT_APP_AWS_BUCKET_URL}${item}`;
  };

  const handlePayslipView = (item) => {
    setPayslipView({
      isView: true,
      url: `${process.env.REACT_APP_AWS_BUCKET_URL}${item}`,
    });
  };

  const renderMonthContent = (month, shortMonth, longMonth, day) => {
    const fullYear = new Date(day).getFullYear();
    const tooltipText = `Month: ${longMonth} ${fullYear}`;

    return <span title={tooltipText}>{shortMonth}</span>;
  };

  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  function handleAdd(values) {
    try {
      setLoader(true);
      axios({
        method: "post",
        url: `${process.env.REACT_APP_SERVER}leave/addLop`,
        data: { date: values.date, userId: userId, value: values.type },
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }).then(function (response) {
        setLoader(false);
        if (response.data.status === true) {
          fetchUserDetails();
          handleNotificationCall("success", response.data.message);
        } else {
          handleNotificationCall("error", response.data.message);
        }
      });
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  }

  const reqPayslip = {
    name:"",
    email:"",
    joinDate:"",
    modeOfPayment:"",
    acCtg:"",
    glCode:"",
    daysInMonth:0,
    lopCount: 0,
    numberOfWorkingDays:0,

    basicAllowanceArrears: 0,
    hraArrears: 0,
    telephoneAllowanceArrear: 0,
    conveyanceArrears: 0,
    medicalAllowanceArrear: 0,
    otherAllowanceArrear: 0,
    bonus: 0,
    incentives: 0,
    otherEarnings: 0,
    arrears: 0,
    consultantArrears: 0,
    statutoryBonusArrears: 0,
    rolePerformanceBonus: 0,
    shiftAllowanceArrears: 0,
    noticePeriodDeduction: 0,
    specialPurposeDeduction: 0,
    standardDeduction: 0,
    totalGross: 0,
    totalDeduction: 0,
    netValue: 0
  }

  return (
    <div style={{ marginTop: "20px" }}>
      <Grid container direction="row" spacing={2} className={classes.heading}>
        <Grid item xs={12} className={classes.drawerClose}>
          <Box display="flex" flexWrap="wrap" gridGap={6}>
            <Box display="flex" flexDirection="column">
              <Button
                variant="outlined"
                size="small"
                color="primary"
                className="example-custom-input"
                endIcon={<IoChevronDownSharp />}
                onClick={handlePayslipCalendarOpen}
              >
                {moment(paymentDate).format("MMM-yyyy")}
              </Button>
              {calendarOpen && (
                <Box
                  position="relative"
                  className="payslip-month-picker-container"
                >
                  <DatePicker
                    selected={paymentDate}
                    onChange={handlePayslipMonthChange}
                    renderMonthContent={renderMonthContent}
                    showMonthYearPicker
                    dateFormat="MM/yyyy"
                    wrapperClassName="payslip-month-calender"
                    popperClassName="payslip-month-calender-popper"
                    inline
                  />
                </Box>
              )}
            </Box>
            <Button
              variant="contained"
              size="small"
              color="primary"
              className={classes.addUser}
              onClick={handlePayslipModalOpen}
            >
              Preview Payslip
            </Button>

            <Button
              variant="contained"
              size="small"
              color="primary"
              startIcon={<AddCircleIcon />}
              className={classes.addUser}
              onClick={handleLOPModalOpen}
            >
              Add LOP
            </Button>
            {!payslipInfo?.isProcessed.status && (
            <Button
              variant="contained"
              size="small"
              color="primary"
              className={classes.addUser}
              onClick={() => handleProcessPayslip("PROCESS")}
            >
              Process Payroll
            </Button>)}
          </Box>
        </Grid>
        <Grid item xs={12} className={classes.drawerClose}>
          <Box display="flex" flexWrap="wrap">
            {payslipInfo?.isProcessed.status && (
              <Box display="flex" flexDirection="column">
                <Alert severity="success">
                  <AlertTitle>Processed On</AlertTitle>
                  {moment(payslipInfo?.isProcessed.processedDate).format(
                    "DD MMM YYYY",
                  )}{" "}
                  -{" "}
                  <Typography
                    component="span"
                    style={{ fontWeight: 600, cursor: "pointer",textDecoration:"underline" }}
                    onClick={() => {
                      setPayslipConfirmationModal(true);
                    }}
                  >
                    Send Payslip
                  </Typography>
                </Alert>
              </Box>
            )}
          </Box>
        </Grid>
        <Grid item xs={12}>
          <PayslipDetails
            userDetails={userData}
            paymentDate={paymentDate}
            currentSalaryData={currentSalaryData}
            payslipData={payslipInfo}
            onUpdate={getPayslipValues}
          />
        </Grid>
      </Grid>

      {payslipData.length === 0 && (
        <NoDataFound height="80vh" message="No Data Found" />
      )}
      {/* <Grid container spacing={2}>
        {payslipData.map((item, index) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
            <Card
              style={{
                background: "#b3ccdb",
                boxShadow:
                  " rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px",
              }}
            >
              <CardMedia
                component="img"
                height="194"
                image={PaySlipImg}
                alt="Paella dish"
              />
              <CardContent>
                <p
                  style={{ fontSize: "20px", fontWeight: "500", margin: "0px" }}
                >
                  Payslip for the Month of{" "}
                  {moment(item.date).format("MMMM YYYY")}
                </p>
              </CardContent>
              <CardActions disableSpacing>
                <IconButton
                  aria-label="add to favorites"
                  onClick={() => {
                    handlePayslipDownload(item.payslipFile);
                  }}
                >
                  <MdFileDownload />
                </IconButton>
                <IconButton
                  aria-label="share"
                  onClick={() => {
                    handlePayslipView(item.payslipFile);
                  }}
                >
                  <MdRemoveRedEye />
                </IconButton>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid> */}

      <Grid container spacing={2} className={classes.pagination}>
        <TablePagination
          rowsPerPageOptions={[10]}
          component="div"
          count={count}
          rowsPerPage={10}
          page={page}
          onPageChange={handleChangePage}
        />
      </Grid>

      <Dialog
        open={payslipModalOpen}
        fullWidth
        maxWidth="lg"
        onClose={handlePayslipModalClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogContent>
          <Box
            display="flex"
            justifyContent="center"
            flexDirection="column"
            alignItems="center"
            style={{ width: "800px", margin: "auto" }}
          >
            {/* <Box
              display="flex"
              justifyContent="end"
              alignItems="center"
              style={{ width: "800px", margin: "auto" }}
            >
              <Button
                variant="contained"
                size="small"
                color="primary"
                startIcon={<IoSendSharp />}
                className={classes.addUser}
                onClick={handleGeneratePdf}
              >
                Generate Payslip
              </Button>
            </Box> */}
            {/* <Grid container direction="row" alignItems="end" spacing={2}>
              <Grid item xs={12} md={6} lg={6}>
                <InputLabel shrink htmlFor="title">
                  Payslip Date
                </InputLabel>
                <DatePicker
                  selected={paymentDate}
                  onChange={(date) => {
                    setPaymentDate(date);
                  }}
                  renderMonthContent={renderMonthContent}
                  showMonthYearPicker
                  dateFormat="MM/yyyy"
                  wrapperClassName="payslip-month-calender"
                  popperClassName="payslip-month-calender-popper"
                />
              </Grid>

              <Grid item xs={12} md={6} lg={6}>
                <InputLabel shrink>Professional Tax Amount</InputLabel>
                <TextField
                  size="small"
                  InputProps={{ disableUnderline: true, min: 0 }}
                  classes={{ root: classes.customTextField }}
                  placeholder="Enter Professional Tax Amount"
                  type="number"
                  value={salaryData.profTax}
                  onChange={handleProfessionalTaxChange}
                />
              </Grid>
            </Grid> */}
          </Box>
          <Box>
            {/* <PaySlipTable
              paymentDate={paymentDate}
              userData={userData}
              salaryData={salaryData}
              leaveData={leaveData}
              setSalaryData={setSalaryData}
              payslipFileRef={payslipFileRef}
              salaryPayslipData={salaryPayslipData}
              currentSalaryData={currentSalaryData}
            /> */}
            <PaySlipTable
              paymentDate={paymentDate}
              userData={userData}
              payslipData={payslipInfo}
              payslipFileRef={payslipFileRef}
              salaryPayslipData={salaryPayslipData}
              currentSalaryData={currentSalaryData}
            />
          </Box>
        </DialogContent>
      </Dialog>

      <Dialog
        open={LOPModalOpen}
        fullWidth
        maxWidth="xs"
        onClose={handleLOPModalClose}
        aria-labelledby="form-dialog-title"
      >
        <form onSubmit={handleSubmit(handleAdd)}>
          <h3 style={{ padding: "12px 12px", fontSize: "16px", margin: 0 }}>
            Add LOP
          </h3>
          {/* <DialogTitle style={{fontSize:"24px"}}>Subscribe</DialogTitle> */}
          <DialogContent>
            <Grid container direction="row" spacing={2}>
              <Grid item xs={12} md={12} lg={12}>
                <InputLabel shrink htmlFor="date">
                  Date
                </InputLabel>
                <FormControl className={classes.margin}>
                  <TextField
                    size="small"
                    type="date"
                    InputProps={{ disableUnderline: true }}
                    classes={{ root: classes.customTextField }}
                    placeholder="Select Date"
                    name="date"
                    {...register("date")}
                    error={errors.date ? true : false}
                  />

                  <Typography variant="inherit" color="error">
                    {errors.date?.message}
                  </Typography>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={12} lg={12}>
                <InputLabel shrink htmlFor="type">
                  Leave Type
                </InputLabel>
                <FormControl className={classes.margin}>
                  <Controller
                    name="type"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <Select
                        value={value}
                        onChange={(e) => onChange(e.target.value)}
                        error={errors.type ? true : false}
                        classes={{
                          root: classes.customSelectField,
                          icon: classes.customSelectIcon,
                        }}
                        disableUnderline
                      >
                        <MenuItem value="">Select option</MenuItem>
                        <MenuItem value="1">Full Day</MenuItem>
                        <MenuItem value="0.5">Half Day</MenuItem>
                      </Select>
                    )}
                  />
                  <Typography variant="inherit" color="error">
                    {errors.type?.message}
                  </Typography>
                </FormControl>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions style={{ padding: "12px 24px" }}>
            <Button
              onClick={handleLOPModalClose}
              variant="contained"
              color="secondary"
              size="small"
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              size="small"
              type="submit"
            >
              Send
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      <Dialog
        open={payslipConfirmationModal}
        fullWidth
        maxWidth="xs"
        onClose={() => {
          setPayslipConfirmationModal(false);
        }}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle>{"Confirmation"}</DialogTitle>
        <DialogContent>
          <DialogContentText paragraph>
            You are about to send this payslip to the employee.
          </DialogContentText>
          <DialogContentText>
            <Alert icon={false} severity="warning">
              <AlertTitle>Note:</AlertTitle>
              <Box component="ul" style={{ listStyle: "disc" }}>
                <Typography component="li">
                  Once the payslip is sent, you will not be able to make any
                  further changes to the payslip details.
                </Typography>
                <Typography component="li">
                  Please review the payslip carefully before proceeding.
                </Typography>
              </Box>
            </Alert>
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ padding: "12px 24px" }}>
          <Button
            onClick={() => {
              setPayslipConfirmationModal(false);
            }}
            variant="contained"
            color="secondary"
            size="small"
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={() => handleProcessPayslip("GENERATE")}
          >
            Send
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        aria-labelledby="dialog-title"
        onClose={handleViewPaySlipClose}
        open={payslipView.isView}
        fullWidth={true}
        maxWidth="md"
        PaperProps={{
          style: {
            width: "100%",
          },
        }}
      >
        <DialogContent>
          <Grid container direction="row" spacing={2}>
            <div
              className={`${classes.heading} ${classes.inputRoot} ${classes.pdfModalTitleText}`}
            >
              <div
                className={classes.inputRoot}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <Typography variant="subtitle2">PAYSLIP</Typography>
              </div>

              <div className={classes.pdfModalCloseBtn}>
                <CloseIcon
                  className={classes.closeBtn}
                  onClick={handleViewPaySlipClose}
                />
              </div>
            </div>
            {payslipView.url ? (
              <Grid item xs={12} style={{ marginTop: "40px" }}>
                <CustomPdfView resumeUrl={payslipView.url} />
              </Grid>
            ) : (
              <Grid item xs={12} style={{ marginTop: "40px", padding: "20px" }}>
                <Typography
                  variant="body"
                  style={{ color: "#686D76", textAlign: "center" }}
                  className={classes.flexCenter}
                >
                  No file found here...
                </Typography>
              </Grid>
            )}
            <div className={classes.sendWhatsapp + " " + classes.inputRoot}>
              <Button
                variant="contained"
                size="small"
                color="secondary"
                onClick={handleViewPaySlipClose}
              >
                Close
              </Button>
            </div>
          </Grid>
        </DialogContent>
      </Dialog>

      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}

export default MyPaySlips;
